module.exports = __webpack_public_path__ + "img/share@2x.82acf248.png";